export const form = {
  email: {
    label: 'E-mail',
    placeholder: "Immettere l'indirizzo della posta"
  },
  name: {
    label: 'Nome',
    placeholder: 'Immettere il nome'
  },
  clubName: {
    label: 'Il nome del club',
    placeholder: 'Immettere il nome del club',
    description: 'Immettere il nome di latino'
  },
  address: {
    label: 'Indirizzo',
    placeholder: "Immettere l'indirizzo"
  },
  workPeriod: {
    start: {
      placeholder: "L'inizio del lavoro"
    },
    end: {
      placeholder: 'Fine del lavoro'
    }
  },
  workTime: {
    start: {
      label: 'Tempo di apertura'
    },
    end: {
      label: 'Tempo di chiusura'
    }
  },
  country: {
    label: 'Indicare la posizione del club',
    placeholder: 'Indicare la posizione del club'
  },
  role: {
    label: 'Posti vacanti nel club'
  },
  currency: {
    label: 'Indicare la valuta dei pagamenti agli artisti',
    placeholder: 'Indicare la valuta dei pagamenti agli artisti'
  },
  nativeLanguage: {
    label: 'Madrelingua',
    placeholder: 'Indica la tua lingua madre'
  },
  lastName: {
    label: 'Cognome',
    placeholder: 'Inserisci il tuo cognome'
  },
  birth: {
    label: 'Data di nascita',
    placeholder: 'Inserisci la data di nascita'
  },
  password: {
    label: 'Password',
    placeholder: 'Immettere la password',
    description:
      'La password deve contenere almeno 8 caratteri del registro superiore e inferiore, numeri e caratteri speciali (ad esempio, !, @, #, $)'
  },
  resetPassword: {
    new: {
      label: 'Nuova password',
      placeholder: 'Immettere una nuova password'
    },
    confirm: {
      label: 'Conferma la password',
      placeholder: 'Immettere una nuova password'
    }
  },
  penalties: {
    placeholder: 'Immettere il nome della multa'
  },
  phone: {
    label: 'Numero di telefono',
    placeholder: '+373-000-00-00'
  },
  buttons: {
    continue: 'Continuare',
    login: 'Entrata',
    send: 'Inviare',
    cancel: 'Cancellare',
    confirm: 'Confermare',
    resend: 'Inviare di nuovo',
    register: 'Registro',
    registerRequest: 'Lascia una domanda di registrazione'
  },
  links: {
    forgotPasswordLink: 'Hai dimenticato la password?',
    login: 'Entrare',
    haveAccount: 'Ho già un account',
    privacy: "Accordo dell'utente e politica di riservatezza."
  },
  other: {
    or: 'O'
  },
  approximateStartDate: {
    label: 'Data di lavoro approssimativa'
  },
  approximateEndDate: {
    label: 'Data approssimativa di fine lavoro'
  },
  search: {
    placeholder: 'Ricerca',
    placeholderCitizienship: 'Cerca la cittadinanza'
  },
  positionItem: {
    label: 'Immettere una posizione'
  },
  paymentFrequency: {
    label: 'La frequenza dei pagamenti'
  },
  price: {
    label: 'Prezzo'
  },
  priceForArtist: {
    label: "Somma all'artista"
  },
  artistPercent: {
    label: "Percentuale per l'artista"
  }
};
